import { gql } from '@apollo/client';

const schema = {
  changeStatus: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder($ids: [String]!, $status_id: String) {
        updateOrder(ids: $ids, status_id: $status_id) {
          model {
            status {
              id
              title
            }
          }
          messages
        }
      }
    `,
  },
};

export default schema;
